import { INDIVIDUAL_SEPARATOR_IDENTIFIER } from '@components/UI-Components/HierarchyWiseItems/constants'

export const extractIndexFromId = (id: string): [string, number] => {
  const [groupId, index] = (id || '').split(INDIVIDUAL_SEPARATOR_IDENTIFIER)
  return [groupId, +index]
}
